import { Injectable, Output,EventEmitter } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { TenantService } from '../services/tenant.service';
import { TenantDto } from '../models/TenantDto';
import { MatDialog } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class RoutingGuardTenant  {
  selectedTenant: TenantDto = new TenantDto();
  selectedTenantId!: string;

  //@Output() setUsername: EventEmitter<boolean> = new EventEmitter();

  constructor(public tenantService: TenantService, public dialog: MatDialog) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    var self = this;
    self.selectedTenantId = this.tenantService.currentTenantId;

    if (self.selectedTenantId == null ) {
      // solange Mandanten Auswahl noch nicht implementiert ist return true, danach dann false
      return true;
    } 

    return true;
  }
}
